<template>
  <el-dialog title="Selecionar Proprietário/Beneficiário" @open="iniciar" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="45%" v-loading="loading">
    <el-form ref="form" :model="proprietarioImovel" :rules="validacao" size="small" label-position="top" hide-required-asterisk :show-message="false">
      <el-row :gutter="10">
        <el-col :span="20">
          <el-form-item label="Cliente" style="width: 100%" prop="proprietarioImovel">
            <el-select v-model="proprietarioImovel" :remote-method="recuperarClientesSelect" :disabled="(!novoProprietario && imovelPossuiAlugueisAnteriores)" :loading="loadingClientes" value-key="id" placeholder 
              loading-text="Carregando clientes" no-data-text="Nenhum cliente encontrado" filterable remote reserve-keyword style="width: 100%">
              <el-option v-for="item in clientesDisponiveis" :key="item.id" :label="formatarSelectCliente(item)" :value="item"/>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item label=" ">
            <el-button type="primary" size="small" v-if="novoProprietario || !imovelPossuiAlugueisAnteriores" style="width: 100%" @click="exibirDialogGravarCliente" round class="btn-box-shadow">Novo</el-button>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-form-item label="Tipo" style="width: 100%" prop="perfil">
          <el-select v-model="perfilProprietario.perfil" style="width: 100%" :disabled="(!novoProprietario || imovelPossuiAlugueisAnteriores)" @change="limparProprietarioDoBeneficiario">
            <el-option label="Proprietário" value="PROPRIETARIO"/>
            <el-option label="Beneficiário" value="BENEFICIARIO"/>
          </el-select>
        </el-form-item>
      </el-row>

      <el-row :gutter="10" v-if="perfilProprietario.perfil === 'PROPRIETARIO'">
        <el-form-item label="Participação no Imóvel(%)" prop="participacaoImovel">
          <el-input-number
              v-model="perfilProprietario.participacaoImovel"
              :precision="2"
              :step="5.0"
              :min="0"
              :max="100"
              controls-position="right">
          </el-input-number>
        </el-form-item>
      </el-row>

      <el-row :gutter="10" v-if="perfilProprietario.perfil === 'BENEFICIARIO'">
        <el-form-item label="Proprietário do Beneficiário" style="width: 100%" prop="proprietarioDoBeneficiario">
            <el-select v-model="perfilProprietario.proprietarioDoBeneficiario" value-key="id" placeholder style="width: 100%">
              <el-option v-for="item in proprietarios" :key="item.id" :label="item.nome" :value="item"/>
            </el-select>
          </el-form-item>
      </el-row>

      <el-row :gutter="10">
        <el-form-item label="Participação no Recebimento(%)" prop="participacaoRecebimento">
          <el-input-number
              v-model="perfilProprietario.participacaoRecebimento"
              :precision="2"
              :step="5.0"
              :min="0"
              :max="100"
              controls-position="right"/>
        </el-form-item>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="confirmarHandler()" type="primary" size="small" round class="btn-box-shadow">Confirmar</el-button>
    </span>

    <app-gravar-cliente-dialog tipo="IMOVEL_ALUGUEL" @close="fecharDialogGravarCliente" :visibility="visibilidadeGravarClienteDialog"/>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";

import AppGravarClienteDialog from "../../../shared/dialogs/GravarClienteDialog.vue";

import URLS from "../../../util/urls.js";
import Util from "../../../util/funcoes.js";


export default {
  components: {
    AppGravarClienteDialog
  },
  props: {
    visibility: Boolean,
    proprietarioSelecionado: Object,
    imovelNovo: Boolean,
    imovelPossuiAlugueisAnteriores: Boolean,
  },
  data() {
    return {
      validacao: {
        proprietarioImovel: [
          {
            type: "object",
            required: true,
            fields: {
              id: { type: "number", required: true, min: 1, trigger: "change" }
            }
          }
        ],
        participacaoImovel: [{ type: "number", min: 0, max: 100 }],
        participacaoRecebimento: [{ type: "number", min: 0, max: 100 }]
      },
      loadingClientes: false,

      proprietarioImovel: {
        id: 0,
        nome: "",
        perfis: Array
      },

      perfilProprietario: {
        participacaoImovel: 0,
        participacaoRecebimento: 0,
        perfil: this.imovelNovo ? "PROPRIETARIO":"BENEFICIARIO",
        proprietarioDoBeneficiario: {}
      },

      clientesDisponiveis: [],

      visibilidadeGravarClienteDialog: false,

      percent: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
        masked: false
      },

      proprietarioSelecionadoData: Object
    };
  },
  computed: {
    ...mapState("alugueisImoveisStore", {
      proprietarios(state) {
        return state.imovelSelecionado.proprietariosBeneficiarios.filter(item => { 
          return item.perfis[0].perfil === 'PROPRIETARIO'
        });
      },
      loading() {
        return this.$store.state.loading;
      }
    }),
    novoProprietario(){
      return !this.proprietarioSelecionado
    }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("loginStore", ["relogar"]),
    ...mapActions("alugueisImoveisStore", ["adicionarProprietarioImovel", "registrarAlteracaoBeneficiario"]),
    iniciar() {
      this.reset();
      if(this.proprietarioSelecionado){
        this.proprietarioSelecionadoData = this.proprietarioSelecionado
        this.proprietarioImovel = Object.assign({}, this.proprietarioSelecionado);
        this.perfilProprietario = Object.assign({}, this.proprietarioSelecionado.perfis[0]);

        this.clientesDisponiveis = [this.proprietarioImovel]
      }
    },
    confirmarHandler() {
      if(this.perfilProprietario.proprietarioDoBeneficiario && this.proprietarioImovel.id === this.perfilProprietario.proprietarioDoBeneficiario.id){
        this.$message.error("Cliente não pode ser Proprietário e Beneficiário");  
        return
      }

      if(this.proprietarioImovel) {
        if(this.perfilProprietario.perfil === 'PROPRIETARIO' || (this.perfilProprietario.perfil === 'BENEFICIARIO' && this.perfilProprietario.proprietarioDoBeneficiario && this.perfilProprietario.proprietarioDoBeneficiario.id)) {
          if((this.perfilProprietario.perfil === 'PROPRIETARIO' && this.perfilProprietario.participacaoRecebimento >= 0) || 
          (this.perfilProprietario.perfil === 'BENEFICIARIO' && this.perfilProprietario.participacaoRecebimento > 0)){
            this.confirmar();
          } else {
            if(this.perfilProprietario.perfil === 'PROPRIETARIO'){
              this.$message.error("Participação no Imóvel deve ser maior que R$ 0,00");  
            } else {
              this.$message.error("Participação no Recebimento deve ser maior que R$ 0,00");  
            }
          }
        } else {
          this.$message.error("Informe o Proprietário/Proprietário do Beneficiário");  
        }
      } else {
        this.$message.error("Preencha todos os campos obrigatórios");
      }
      
    },
    confirmar() {
      if(!this.proprietarioSelecionado){
        this.proprietarioImovel.perfis = []
        this.proprietarioImovel.perfis.push(this.perfilProprietario)
        let payload = this.proprietarioImovel

        this.adicionarProprietarioImovel(payload)
        this.registrarAlteracaoBeneficiario();
      } else {
        this.proprietarioSelecionadoData = Object.assign({}, this.proprietarioImovel);
        this.proprietarioSelecionadoData.perfis[0] = Object.assign({}, this.perfilProprietario);
      }
      this.fechar()
    },
    recuperarClientesSelect(queryString) {
      const numberRegexPattern = /^\d+$/;

      const isPesquisaPorId = numberRegexPattern.test(queryString);
      const parametroDaPesquisa = isPesquisaPorId ? 'idNaImobiliaria' : 'nome';

      const payload = { [parametroDaPesquisa]: queryString };
      
      this.loadingClientes = true;

      this.listarClientes(payload)
        .then(resultado => {
          const clientes = resultado.lista;

          const porClientesNaoPresentesNosProprietarios = cliente => {
            const idsProprietariosJaPresentes = this.proprietarios.map(proprietario => proprietario.id);
            const clienteNaoEstaPresenteNosProprietarios = !idsProprietariosJaPresentes.includes(cliente.id);

            return clienteNaoEstaPresenteNosProprietarios;
          };

          this.clientesDisponiveis = clientes.filter(porClientesNaoPresentesNosProprietarios);
        })
        .catch(() => {
          this.clientesDisponiveis = [];
        })
        .finally(() => {
          this.loadingClientes = false;
        });
    },
    listarClientes(payload) {
      return axios.post(URLS.CLIENTES_LISTAR, payload)
        .then(response => {
          if(response.data.status === 'SESSAO_EXPIRADA') {
            return this.relogar()
              .then(authResponse => {
                if(authResponse.status === 'SUCESSO') {
                  return this.listarClientes(payload);
                }
              });
          }

          return response.data;
        })
        .catch(error => {
          throw error;
        });
    },
    exibirDialogGravarCliente() {
      this.visibilidadeGravarClienteDialog = true;
    },
    fecharDialogGravarCliente(cliente) {
      if(cliente){
        this.proprietarioImovel = cliente;
        this.clientesDisponiveis = [cliente];
      }
      this.visibilidadeGravarClienteDialog = false;
    },
    formatarSelectCliente(cliente){
      return Util.formatarSelectCliente(cliente);
    },
    limparProprietarioDoBeneficiario(){
      this.perfilProprietario.participacaoImovel = 0;
      this.perfilProprietario.participacaoRecebimento = 0;
    },
    reset() {
      this.proprietarioImovel = {
        id: 0,
        nome: "",
        perfis: Array
      },

      this.perfilProprietario = {
        participacaoImovel: 0,
        participacaoRecebimento: 0,
        perfil: this.imovelNovo ? "PROPRIETARIO":"BENEFICIARIO",
        proprietarioDoBeneficiario: {}
      },
      this.clientesDisponiveis = [];
    },
    fechar() {
      this.$refs["form"].resetFields();
      this.$emit("close");
    }
  }
};
</script>